import { render } from "./ChangeMaterialStatus.vue?vue&type=template&id=46254010"
import script from "./ChangeMaterialStatus.vue?vue&type=script&lang=js"
export * from "./ChangeMaterialStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm});
